import {createFeatureSelector, createSelector} from "@ngrx/store";
import {ISharedPermissionsStoreState} from "./shared-permissions.state";

export const sharedPermissionsSelect = createFeatureSelector<ISharedPermissionsStoreState>('sharedPermissions');

export const selectUserPermissions = createSelector(
  sharedPermissionsSelect,
  (state: ISharedPermissionsStoreState) => state.userPermissions
);

export const selectLoaded = createSelector(
  sharedPermissionsSelect,
  (state: ISharedPermissionsStoreState) => state.loaded
);

export const selectFeatureFlag = createSelector(
  sharedPermissionsSelect,
  (state: ISharedPermissionsStoreState) => state?.userFeatureFlags
);
